<template>
    <div id="wordCloud" ></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import * as am4plugins_wordCloud from '@amcharts/amcharts4/plugins/wordCloud'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

import MetodosGlobais from '@/utils/MetodosGlobais'
import CorUtil from '@/utils/CorUtils'


export default {
  name: 'sp-tag-cloud',
  props: {
    data: { Type: Array },
    titulo: { type: String, default: 'Nuvem de Palavras' },
    fontSize: { type: String },
    fontWeight: { type: String },
    fontFamily: { type: String },
    subTitulo: { type: String },
    word: { type: String },
    value: { type: String },
    hovercolor: {},
    templateUrl: {},
    templateUrlTarget: {},
    heatMax: { type: String },
    heatMin: { type: String },
    cores: { type: String, default: '#000' },
    maxFont: { type: Number },
    minFont: { type: Number },
  },

  data () {
    return {
      chart: new Object(),
      series: new Object(),
    }
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  },

  mounted () {
    try {
      am4core.useTheme(am4themes_animated)
    } catch (error) {
      console.error(error)
    }
  },

  methods: {
    getChart () {
      return this.chart
    },

    setChart (chart) {
      this.chart = chart
    },

    getSeries () {
      return this.chart.series.push(new am4plugins_wordCloud.WordCloudSeries())
    },

    setSeries (series) {
      this.series = series
    },

    defineSeries (chart, data, word, value, maxFont, minFont, heatMax, heatMin, hovercolor) {
      let series = chart.series.push(new am4plugins_wordCloud.WordCloudSeries())
      series.randomness = 0.4
      series.rotationThreshold = 0
      series.accuracy = 2
      if (maxFont) series.maxFontSize = am4core.percent(maxFont)
      else series.maxFontSize = am4core.percent(30)
      if (minFont) series.minFontSize = am4core.percent(minFont)
      else series.minFontSize = am4core.percent(2)
      series.maxCount = 100

      series.events.on('arrangestarted', function (ev) {
        ev.target.baseSprite.preloader.show(0)
      })

      series.events.on('arrangeprogress', function (ev) {
        ev.target.baseSprite.preloader.progress = ev.progress
      })

      series.data = data
      series.dataFields.word = word
      series.dataFields.value = value
      series.heatRules.push({
        'target': series.labels.template,
        'property': 'fill',
        'min': am4core.color(heatMin),
        'max': am4core.color(heatMax),
        'dataField': 'value',
      })

      // series.labels.template.url = templateUrl;
      // series.labels.template.urlTarget = templateUrlTarget;
      series.labels.template.tooltipText = '{word}: {value}'
      let hoverState = series.labels.template.states.create('hover')
      hoverState.properties.fill = am4core.color(hovercolor)

      return series
    },

    defineChart (titulo, subTitulo, fontSize, fontWeight, fontFamily) {
      let chart = am4core.create('wordCloud', am4plugins_wordCloud.WordCloud)
      chart.fontFamily = fontFamily || 'Courier New'
      let title = chart.titles.create()
      title.text = titulo
      title.fontSize = fontSize || 20
      title.fontWeight = fontWeight || '800'
      if (subTitulo) {
        let subtitle = this.chart.titles.create()
        subtitle.text = subTitulo
      };
      return chart
    },
  },
}
</script>

<style scoped>
    #wordCloud {
        width: 100%;
        height: 600px;
    }
</style>
